import { render, staticRenderFns } from "./HouseholdFrame.vue?vue&type=template&id=55277946&scoped=true"
import script from "./HouseholdFrame.vue?vue&type=script&lang=js"
export * from "./HouseholdFrame.vue?vue&type=script&lang=js"
import style0 from "./HouseholdFrame.vue?vue&type=style&index=0&id=55277946&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55277946",
  null
  
)

export default component.exports